var exports = {
  "TQ": "Checkbox.module__checkboxWrapper___cGhWdW",
  "r9": "Checkbox.module__disabled___cGhWdW",
  "iD": "Checkbox.module__menuDisabled___cGhWdW",
  "kv": "Checkbox.module__checkbox___cGhWdW",
  "aP": "Checkbox.module__box___cGhWdW",
  "LI": "Checkbox.module__round___cGhWdW",
  "KD": "Checkbox.module__checked___cGhWdW",
  "oE": "Checkbox.module__checkIcon___cGhWdW",
  "Pf": "Checkbox.module__label___cGhWdW",
  "hJ": "Checkbox.module__labelInteractive___cGhWdW",
  "QK": "Checkbox.module__labelText___cGhWdW",
  "nV": "Checkbox.module__labelFocusRing___cGhWdW",
  "P8": "Checkbox.module__menuChecked___cGhWdW",
  "fb": "Checkbox.module__checkboxIndicator___cGhWdW",
};

module.exports = exports;
